import { getClient } from '@lib/sanity'
import { loadTranslation } from '@lib/i18n'
import { groq } from 'next-sanity'
import MemberView from 'components/MemberView'

export const getStaticPaths = async ({ locales }) => {
  const pageQueries = await getClient().fetch(
    groq`*[_type in ["member"] && defined(slug.current)]{slug}`
  )

  const pagePaths = []
  pageQueries.forEach((page) => {
    locales.forEach((locale) => {
      pagePaths.push({
        params: {
          slug: page.slug.current,
          locale,
        },
      })
    })
  })
  return { paths: pagePaths, fallback: 'blocking' }
}

const query = [
  `"member": *[_type == "member" && slug.current == $slug][0]{..., region[]->}`,
  `"posts": *[_type == "post" && locale == $locale && type in ["news", "events", "publications", "press", "blog"] && ($slug in authors[]->slug.current || $slug in relatedProfiles[]->slug.current)] | order(publishedAt desc)[0...9]{_id, title, _type, type, mainImage, excerpt, body, publishedAt, eventStart, eventEnd, eventLocation, slug}`,
]

export const getStaticProps = async ({ locale, params, preview = false }) => {
  const translation = await loadTranslation(
    locale,
    process.env.NODE_ENV === 'production'
  )
  const member = await getClient(preview).fetch(
    groq`{
    ${query.join(',\n')}
  }`,
    {
      slug: params.slug,
      locale,
    }
  )

  if (!member || !member.member) {
    return {
      notFound: true,
    }
  }

  return {
    props: {
      translation,
      member: member.member,
      posts: member.posts,
      preview,
    },
    revalidate: 60 * 5, // Every five mins
  }
}

export default MemberView
